import * as React from 'react';

import FlexBox from './FlexBox';

type Props = React.ComponentProps<typeof FlexBox>;

export default React.forwardRef<HTMLDivElement, Props>((props, ref) => (
    <FlexBox ref={ref} direction="column" {...props} />
));
